<template>
    <div>
        <div class="download-animation-badge" v-if="downloadAnimation" />
        <v-menu v-model="showToolTip" offset-x location="bottom">
            <template #activator="{ props }">
                <span v-bind="props" />
            </template>
        </v-menu>
        <v-menu
            offset-y
            v-model="menuIsOpen"
            :close-on-click="true"
            :close-on-content-click="false"
            location="bottom"
        >
            <template #activator="{ props }">
                <v-btn icon=" $oss-bell " color="primary" v-bind="props" />
            </template>
            <v-row
                style="
                    background: #fff;
                    width: 500px;
                    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
                    border-radius: 8px;
                    background-color: white;
                "
            >
                <v-col cols="12" class="d-flex align-center title py-3 px-4 font-weight-medium">
                    Notifications
                </v-col>
                <v-col cols="12">
                    <v-tabs v-model="step" fixed-tabs height="36px">
                        <v-tab value="ALL">
                            <strong>Tous</strong>
                        </v-tab>
                        <v-tab value="DOCUMENT">
                            <strong>Document</strong>
                            <v-badge
                                v-if="numberOfUnreadDocument !== 0"
                                :content="numberOfUnreadDocument"
                                floating
                            >
                            </v-badge>
                        </v-tab>
                        <v-tab value="CHAT_MESSAGE">
                            <strong>Chat</strong>
                            <v-badge
                                v-if="numberOfUnreadChatMessages !== 0"
                                :content="numberOfUnreadChatMessages"
                                floating
                            >
                            </v-badge>
                        </v-tab>
                        <v-tab value="IMPORT">
                            <strong>Import</strong>
                            <v-badge
                                v-if="numberOfUnreadImport !== 0"
                                :content="numberOfUnreadImport"
                                floating
                            >
                            </v-badge>
                        </v-tab>
                        <v-tab value="EXPORT">
                            <strong>Export</strong>
                            <v-badge
                                v-if="numberOfUnreadExport !== 0"
                                :content="numberOfUnreadExport"
                                floating
                            >
                            </v-badge>
                        </v-tab>
                    </v-tabs>
                </v-col>
                <v-col cols="12" class="px-2 py-0">
                    <v-list style="max-height: 70vh; overflow-y: auto">
                        <v-list-item
                            v-if="!filteredNotifications.length"
                            class="d-flex justify-center py-4"
                        >
                            <v-list-item-title> Aucune notification </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-for="(n, index) of filteredNotifications"
                            :key="index"
                            :class="getNotificationClass(n)"
                        >
                            <template #prepend>
                                <v-icon v-if="n.icon">{{ n.icon }}</v-icon>
                            </template>

                            <template v-if="n.scope === 'document'">
                                <v-list-item-title>
                                    {{ $t("notification.document.create", n.datas.length) }}
                                </v-list-item-title>
                                <v-list-item
                                    v-for="(d, index) of n.datas.slice(0, 2)"
                                    :key="index"
                                    class="notification--sub-card"
                                    @click="routerPushDocument(d)"
                                >
                                    <v-list-item-title>
                                        <strong>{{ d.name }}</strong>
                                    </v-list-item-title>
                                    <template #prepend>
                                        <v-icon size="small">$oss-chevron-right</v-icon>
                                    </template>
                                </v-list-item>
                                <div class="d-flex justify-center py-2" v-if="n.datas.length > 2">
                                    {{
                                        $t("notification.document.andMore", n.datas.length - 2, {
                                            count: n.datas.length - 2,
                                        })
                                    }}
                                </div>
                            </template>
                            <template v-else-if="n.scope === 'chatMessage'">
                                <v-list-item-subtitle class="pb-2">
                                    {{ n.data.sender.firstname || "" }}
                                    {{ n.data.sender.lastname || "" }}
                                </v-list-item-subtitle>
                                <v-list-item-title style="white-space: normal">
                                    {{ n.data.text }}
                                </v-list-item-title>
                            </template>
                            <template v-else-if="n.scope === 'accountingItemExport'">
                                <v-list-item-subtitle class="pb-2">
                                    {{ n.text }}
                                </v-list-item-subtitle>
                                <v-progress-linear
                                    rounded
                                    v-if="n.data && n.data.step < n.data.stepCount"
                                    :model-value="(n.data.step / n.data.stepCount) * 100"
                                    location="bottom"
                                />
                            </template>
                            <template v-else-if="n.scope === 'accountingItemImport'">
                                <v-list-item-subtitle class="pb-2">
                                    {{ n.text }}
                                </v-list-item-subtitle>
                                <v-progress-linear
                                    rounded
                                    v-if="n.data && n.data.step < n.data.stepCount"
                                    :model-value="(n.data.step / n.data.stepCount) * 100"
                                    location="bottom"
                                />
                            </template>
                            <template
                                v-else-if="
                                    ['invoice', 'engagementLetter', 'openPoints'].includes(n.scope)
                                "
                            >
                                <v-list-item-subtitle class="pb-2">
                                    {{ n.text }}
                                </v-list-item-subtitle>
                                <v-progress-linear
                                    rounded
                                    v-if="n.extraData && n.extraData.step < n.extraData.stepCount"
                                    :model-value="(n.extraData.step / n.extraData.stepCount) * 100"
                                    location="bottom"
                                />
                            </template>

                            <template v-else>
                                <v-list-item-title>
                                    {{ n.text || "" }}
                                    <div v-if="n.user">{{ n.user }}</div>
                                </v-list-item-title>
                            </template>
                            <template #append>
                                <v-btn-icon
                                    icon="$oss-download"
                                    @click="directDownload(n)"
                                    v-if="isUnreadNotification(n)"
                                    size="small"
                                />
                            </template>
                        </v-list-item>
                    </v-list>
                </v-col>
                <v-col cols="12">
                    <v-divider />
                </v-col>
                <v-col cols="12" class="pa-2">
                    <v-btn color="primary" variant="text" @click="markAllAsRead">
                        <v-icon size="small" left>$fa-check-double</v-icon>
                        Marquer comme lu
                    </v-btn>
                </v-col>
            </v-row>
        </v-menu>
    </div>
</template>

<script lang="ts">
import { NotificationBase } from "./NotificationBase";
import { State2Way } from "@/decorators";

import { updateMaintenance } from "../services/updateMaintenance";

import getEnv from "../env";
import { getUserDisplayName } from "../services/userServices";
import moment from "moment-timezone";
const env = getEnv();
import { User } from "../store/store";
import { Component, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component
export class Notification extends NotificationBase {
    @State2Way("updateNotifications", "notifications")
    notifications!: any[];

    menuIsOpen = false;
    showToolTip = false;

    lastDateOpenNotificationCenter = null;

    step = "ALL";

    get currentUser(): User {
        return this.$store.state.user;
    }

    get unreadNotifications() {
        return this.notifications.filter(
            (n) => n?.pushDate?.isAfter && n.pushDate.isAfter(this.lastDateOpenNotificationCenter),
        );
    }

    get lastUnreadNotification() {
        return this.unreadNotifications[this.unreadNotifications.length - 1];
    }

    get numberOfUnreadNotifications() {
        const result = this.unreadNotifications.length;
        if (result > 9) {
            return "9+";
        }
        return result;
    }

    get numberOfUnreadChatMessages() {
        const result = this.unreadNotifications.filter((n) => n.scope === "chatMessage").length;
        if (result > 9) {
            return "9+";
        }
        return result;
    }

    get numberOfUnreadImport() {
        const result = this.unreadNotifications.filter(
            (n) => n.scope === "accountingItemImport",
        ).length;
        if (result > 9) {
            return "9+";
        }
        return result;
    }

    get numberOfUnreadExport() {
        const result = this.unreadNotifications.filter(
            (n) => n.scope === "accountingItemExport",
        ).length;
        if (result > 9) {
            return "9+";
        }
        return result;
    }

    get numberOfUnreadDocument() {
        const result = this.unreadNotifications.filter((n) => n.scope === "document").length;
        if (result > 9) {
            return "9+";
        }
        return result;
    }

    get haveUnreadNotifications() {
        return this.unreadNotifications.length > 0;
    }

    get filteredNotifications() {
        let result = [...this.notifications];
        if (this.step === "DOCUMENT") {
            result = result.filter((n) => n.scope === "document" || n.scope === "invoice");
        } else if (this.step === "CHAT_MESSAGE") {
            result = result.filter((n) => n.scope === "chatMessage");
        } else if (this.step === "EXPORT") {
            result = result.filter((n) => n.scope === "accountingItemExport");
        } else if (this.step === "IMPORT") {
            result = result.filter((n) => n.scope === "accountingItemImport");
        }
        return result.sort((a, b) => {
            if (a.pushDate.isBefore(b.pushDate)) {
                return 1;
            }
            if (a.pushDate.isAfter(b.pushDate)) {
                return -1;
            }
            return 0;
        });
    }

    get mainNotification() {
        return this.notifications.find(
            (n) =>
                (n.data?.stepCount && n.data.step < n.data.stepCount) ||
                (n.extraData?.stepCount && n.extraData.step < n.extraData.stepCount),
        );
    }

    get companyId() {
        return this.$store.state.selected_company?.id;
    }

    beforeMount() {
        this.lastDateOpenNotificationCenter = moment();
        for (const notif of this.notifications) {
            notif.pushDate = moment(notif.pushDate);
        }

        this.lastDateOpenNotificationCenter = moment();
        // this.notifications.push({
        //     display: true,
        //     timeout: 50000,
        //     text: "Bienvenue",
        //     pushDate: moment().add(1, "seconds"),
        // })
        // this.notifications.push({
        //     display: true,
        //     timeout: 50000,
        //     text: "Bienvenue",
        //     pushDate: moment().add(1, "seconds"),
        // })
        // this.notifications.push({
        //     display: true,
        //     timeout: 50000,
        //     text: "Bienvenue",
        //     pushDate: moment().subtract(1, "minutes"),
        // })
        // this.addListener("all")
        this.addListener([
            "frontEvent",
            "applicationSettings",
            "document",
            "invoice",
            "expenseReport",
            "accountingItemImport",
            "accountingItemExport",
            "chatMessage",
            "openPoints",
            "bankTransaction",
            "documentAndBankTransaction",
            "accountingPeriod",
        ]);

        window.onoffline = (event) => {
            this.onOffline();
        };
        window.ononline = (event) => {
            this.onOnline();
        };
        // window.onpagehide = (event) => {
        //     this.onPageHide();
        // };
        // window.onblur = (event) => {
        //     this.onPageHide();
        // };
        //  window.onpageshow = (event) => {
        //     this.onPageShow();
        // };
        // window.onfocus = (event) => {
        //     this.onPageShow();
        // };
        // window.onpause = (event) => {
        //     this.onPause();
        // };
        // window.onmessage = (event) => {
        //     console.log(event)
        // };

        // window.on = (event) => {
        //     this.onResume();
        // };

        // document.addEventListener('deviceready', function onDeviceReady() {
        // document.addEventListener("offline", Notification._onOnline, false);
        // document.addEventListener("online", Notification._onOnline, false);
        // document.addEventListener("pause", Notification._onPause, false);
        // document.addEventListener("resume", Notification._onResume, false);
        // })
    }

    onOffline() {
        const notifIndex = this.notifications.findIndex((n) => n.scope === "connection");
        if (notifIndex !== -1) {
            const notif = this.notifications[notifIndex];
            notif.text = "La connexion internet a été perdue";
            notif.pushDate = moment();
            if (notifIndex) {
                this.notifications.splice(notifIndex, 1);
                this.notifications.unshift(notif);
            }
        } else {
            this.notifications.push({
                scope: "connection",
                display: true,
                // timeout: 2000,
                text: "La connexion internet a été perdue",
                pushDate: moment(),
            });
        }
    }

    onOnline() {
        const notifIndex = this.notifications.findIndex((n) => n.scope === "connection");
        if (notifIndex !== -1) {
            const notif = this.notifications[notifIndex];
            notif.text = "La connexion internet a été rétablie";
            notif.pushDate = moment();
            if (notifIndex) {
                this.notifications.splice(notifIndex, 1);
                this.notifications.unshift(notif);
            }
        } else {
            this.notifications.push({
                icone: "",
                scope: "connection",
                display: true,
                // timeout: 2000,
                text: "La connexion internet a été rétablie",
                pushDate: moment(),
            });
        }
    }

    onPause() {
        console.log("Pause");
    }

    onResume() {
        this.notifications.push({
            icone: "",
            display: true,
            timeout: 2000,
            text: "Bienvenue",
            pushDate: moment(),
        });
    }

    onPageHide() {
        console.log("Hide");
    }

    onPageShow() {
        console.log("Show");
    }

    beforeDestroy() {
        this.removeListener();
    }

    onMessage(data) {
        if (data) {
            if (data.action === "download") {
                this.startDownloadAnimation(data);
            }
            if (data.scope === "applicationSettings") {
                updateMaintenance(this.$route, this.$store, this.$router, data.payload);
                return;
            }
            if (data.scope === "frontEvent") {
                const snackBar = {
                    scope: "frontEvent",
                    display: true,
                    timeout: 2000,
                    text: data.text,
                    pushDate: moment(),
                };
                this.notifications.unshift(snackBar);
                return;
            }

            if (data.scope === "chatMessage" || data.scope === "document") {
                if (data.user?.id === this.currentUser?.id) {
                    console.log("onMessage modified by me");
                    return;
                }
            }

            if (data.id) {
                const notification = this.notifications.find(
                    (notif) => notif.data?.id && notif.data?.id === data.id,
                );
                if (notification) {
                    notification.data = data.payload;
                    if (data.extraPayload) {
                        notification.extraData = data.extraPayload;
                    }
                    return;
                }
            }
            if (data.scope === "document") {
                return this.onDocument(data);
            }
            if (data.scope === "chatMessage") {
                return this.onChatMessage(data);
            }
            if (data.scope === "accountingItemImport" && data.action !== "delete") {
                return this.onImport(data);
            }
            if (data.scope === "accountingItemExport" && data.action !== "delete") {
                this.startDownloadAnimation(data);
                return this.onExport(data);
            }
            if (data.scope === "invoice") {
                if (data.action === "download" || data.action === "beingValidated") {
                    return this.onInvoice(data);
                } else {
                    console.log("invoice action=", data.action);
                }
                return;
            }
            if (data.scope === "engagementLetter") {
                if (data.action === "download" || data.action === "beingValidated") {
                    return this.onEngagementLetter(data);
                }
                return;
            }
            if (data.scope === "openPoints") {
                if (data.action === "download") {
                    return this.onOpenPoints(data);
                }
                return;
            }

            if (data.scope === "documentAndBankTransaction") {
                if (data.action === "delete") {
                    return this.onDeleteDocumentAndBankTransaction(data);
                }
                return;
            }
            if (data.scope === "bankTransaction") {
                if (data.action === "delete") {
                    return this.onDeleteBankTransaction(data);
                }
                return;
            }
            if (data.scope === "accountingPeriod") {
                if (
                    data.action === "computeCarryForward" ||
                    data.action === "closeAccountingPeriod"
                ) {
                    return this.onAccountingPeriodChanged(data);
                }
                return;
            }

            const notification = {
                icon: "",
                // display: true,
                // timeout: 15000,
                text: "",
                pushDate: moment(),
                data,
                extraData: null,
                user: null,
            };
            if (data.extraPayload) {
                notification.extraData = data.extraPayload;
            }
            notification.text = this.$t("notification.action." + data.action) + " ";
            notification.text += this.$t("notification.scope." + data.scope);
            if (data.user) {
                notification.user = getUserDisplayName(data.user);
            }
            this.notifications.unshift(notification);
        }
    }

    onDocument(data) {
        if (data.action === "create") {
            const pushDate = moment();
            // console.log(pushDate)
            let notification = this.notifications.find((notif) => {
                // console.log(sb.pushDate.isSame(pushDate, "day"))
                return (
                    notif.action === "create" &&
                    notif.scope === "document" &&
                    notif.pushDate.isSame(pushDate, "day")
                );
            });
            if (!notification) {
                notification = {
                    icon: "$oss-archives",
                    pushDate,
                    scope: data.scope,
                    action: data.action,
                    datas: [
                        {
                            name: data.payload.displayName || data.payload.name,
                            id: data.id,
                            companyId: data.companyId,
                        },
                    ],
                };
                return this.notifications.unshift(notification);
            }
            notification.datas.unshift({
                name: data.payload.displayName || data.payload.name,
                id: data.id,
                companyId: data.companyId,
            });
            notification.pushDate = pushDate;
            return notification;
        }
    }

    onChatMessage(data) {
        const notification = {
            icon: "$oss-chat-filled",
            scope: data.scope,
            action: data.action,
            pushDate: moment(),
            data: data.payload,
        };
        notification.data.userDisplayName = getUserDisplayName(notification.data.user);
        this.notifications.unshift(notification);
        const notificationBell = document.getElementById("notification-bell");
        if (notificationBell) {
            notificationBell.style.animation =
                "notify 1s cubic-bezier(0.455, 0.03, 0.515, 0.955) both 1";
            this.showToolTip = true;
            setTimeout(() => {
                notificationBell.style.animation = "";
            }, 1500);
        }
    }

    onImport(data) {
        debugger;
        const notification = {
            icon: "$oss-import",
            scope: data.scope,
            action: data.action,
            pushDate: moment(),
            text: "Import ",
            data: data.payload,
        };
        if (data.payload) {
            notification.text += data.payload.name;
        }
        this.notifications.unshift(notification);
    }

    onExport(data) {
        const notification = {
            icon: "$oss-export",
            scope: data.scope,
            action: data.action,
            pushDate: moment(),
            text: "Export ",
            data: data.payload,
        };
        if (data.payload) {
            notification.text += data.payload.name;
        }
        this.notifications.unshift(notification);
    }

    onInvoice(data) {
        // debugger
        const notification = {
            icon: "$oss-export",
            scope: data.scope,
            action: data.action,
            pushDate: moment(),
            text: data.action === "beingValidated" ? "Validation " : "Téléchargement ",
            data: data.payload,
            extraData: data.extraPayload,
        };
        if (data.payload.title) {
            notification.text += data.payload.title;
        }
        this.notifications.unshift(notification);
    }

    onEngagementLetter(data) {
        const notification = {
            icon: "$oss-export",
            scope: data.scope,
            action: data.action,
            pushDate: moment(),
            text:
                data.action === "beingValidated"
                    ? "Validation :  lettre de mission"
                    : "Téléchargement: lettre de mission",
            data: data.payload,
            extraData: data.extraPayload,
        };
        this.notifications.unshift(notification);
    }

    onOpenPoints(data) {
        const notification = {
            icon: "$oss-export",
            scope: data.scope,
            action: data.action,
            pushDate: moment(),
            text: "",
            data: data.payload,
            extraData: data.extraPayload,
        };
        notification.text = this.$t("notification.action." + data.action) + " ";
        notification.text += this.$t("notification.scope." + data.scope);
        this.notifications.unshift(notification);
    }

    onDeleteDocumentAndBankTransaction(data) {
        const notification = {
            icon: "$oss-trash",
            scope: data.scope,
            action: data.action,
            pushDate: moment(),
            text: this.$t("notification.documentAndBankTransaction.delete"),
            data: data.payload,
            extraData: data.extraPayload,
        };
        this.notifications.unshift(notification);
    }

    onDeleteBankTransaction(data) {
        const notification = {
            icon: "$oss-trash",
            scope: data.scope,
            action: data.action,
            pushDate: moment(),
            text: this.$t("notification.bankTransaction.delete"),
            data: data.payload,
            extraData: data.extraPayload,
        };
        this.notifications.unshift(notification);
    }

    onAccountingPeriodChanged(data) {
        const notification = {
            icon: "$fa-gear",
            scope: data.scope,
            action: data.action,
            pushDate: moment(),
            text: this.$t("notification.accountingPeriod." + data.action),
            data: data.payload,
            extraData: data.extraPayload,
        };
        this.notifications.unshift(notification);
    }

    deleteSnackBar(sb) {
        const index = this.notifications.findIndex((sbi) => sbi === sb);
        if (index !== -1) {
            this.notifications.splice(index, 1);
            console.log("sb remover");
        }
    }

    openDocument(companyId, documentId) {
        this.$router.push({
            name: "document",
            params: {
                companyId: companyId,
                id: documentId,
            },
        });
    }

    openObject(sb) {
        if (sb.data && sb.data.scope && sb.data.id && sb.data.companyId) {
            if (sb.data.scope === "document") {
                this.openDocument(sb.data.companyId, sb.data.id);
            } else if (sb.data.scope === "chatMessage") {
                const chat = sb.data.chat;
                if (chat.type === "COMPANY") {
                    this.$router.push({ name: "chat" });
                } else if (chat.documentId) {
                    this.openDocument(chat.comanyId, chat.documentId);
                } else {
                    // NOT IMPLEMENTED YET
                    debugger; // git-ignore
                }
            }
        }
    }

    enableOpen(sb) {
        const documentTypes = ["document", "chatMessage"];
        if (sb.data?.action === "create" || sb.data?.action === "update") {
            if (documentTypes.indexOf(sb.data.scope) !== -1) {
                return true;
            }
        }
        return false;
    }

    directDownload(notif) {
        if (notif.data?.file) {
            window.open(
                `${env.VUE_APP_BACKEND}/${notif.scope}/download/${notif.data.id}`,
                "_blank",
            );
        }
    }

    directDownloadSignedUrl(notif) {
        if (notif?.extraData?.signedUrl) {
            window.open(notif.extraData.signedUrl, "_blank");
        }
    }

    downloadAnimation = false;
    downloadNotif = null;
    animationTimeout = null;

    startDownloadAnimation(notif) {
        if (!this.downloadNotif || this.downloadNotif.id !== notif.id) {
            if (this.animationTimeout) {
                clearTimeout(this.animationTimeout);
                this.animationTimeout = null;
            }
            this.downloadAnimation = true;
            this.animationTimeout = setTimeout(() => {
                this.downloadAnimation = false;
                this.animationTimeout = null;
            }, 2500);
        }
    }

    deleteSnackbar(snackbar) {
        const index = this.notifications.find((sb) => sb === snackbar);
        if (index !== -1) {
            this.notifications.splice(index, 1);
        }
    }

    isUnreadNotification(notification) {
        return notification.pushDate.isAfter(this.lastDateOpenNotificationCenter);
    }

    getNotificationClass(notification) {
        let nc = "mb-2";
        if (notification.scope === "document") {
            nc += " notification";
        } else {
            nc += " notification--sub-card";
        }
        return nc;
    }

    markAllAsRead() {
        this.lastDateOpenNotificationCenter = moment();
    }

    formatDate(date) {
        return date.format("DD MMMM");
    }

    pushDateFormat(date) {
        // if date is more than 3 days ago, show date
        // if (moment().diff(date, 'days') > 3) {
        //     return this.formatDate(date)
        // }
        // return date.fromNow(true)
        const now = moment();
        let count = now.diff(date, "years");
        if (count) {
            return count + " a";
        }
        count = now.diff(date, "months");
        if (count) {
            return count + " m";
        }
        count = now.diff(date, "days");
        if (count) {
            return count + " j";
        }
        count = now.diff(date, "hours");
        if (count) {
            return count + " h";
        }
        count = now.diff(date, "minutes");
        if (count) {
            return count + " m";
        }
        count = now.diff(date, "seconds");
        if (count) {
            return count + " s";
        }
        count = now.diff(date, "milliseconds");
        if (count) {
            return "now";
        }
        return date.fromNow(true);
    }

    routerPushDocument(document) {
        this.$router.push({
            name: "document",
            params: {
                companyId: document.companyId,
                id: document.id,
            },
        });
        this.menuIsOpen = false;
    }

    @Watch("menuIsOpen")
    onMenuIsOpenChange() {
        if (!this.menuIsOpen) {
            this.lastDateOpenNotificationCenter = moment();
        }
    }

    pushDocument() {
        this.onMessage({
            scope: "document",
            action: "create",
            id: "ckiq2xk4i0hej0878z0nti7j6",
            companyId: "ckiq2xj250gfu087815mcjusc",
            payload: {
                name: "GOOGLE IRELAND LIMITED",
                step: 1,
                stepCount: 2,
            },
        });
        this.onMessage({
            scope: "document",
            action: "create",
            id: "ckiq2xk3p0hdz0878k4yfpzzh",
            companyId: "ckiq2xj250gfu087815mcjusc",
            payload: {
                name: "FREE MOBILE",
                step: 1,
                stepCount: 2,
            },
        });
    }

    pushMessage() {
        this.onMessage({
            scope: "chatMessage",
            action: "create",
            payload: {
                user: {
                    firstname: "John",
                    lastname: "Doe",
                    id: "ckiq2xj250gfu087815mcjusc",
                },
                message:
                    "Hello, I am John Doe, I am the CEO of Google Ireland Limited. I would like to know more about your company.",
            },
        });
    }

    pushExport() {
        this.onMessage({
            scope: "accountingItemExport",
            action: "create",
            id: "ckiq2xk3p0hdz0878k4yfpzzh",
            companyId: "ckiq2xj250gfu087815mcjusc",
            payload: {
                name: "Export FEC 2022",
                step: 3,
                stepCount: 10,
            },
        });
    }

    @Watch("companyId")
    onCompanyIdChange() {
        this.notifications = [];
    }

    get progressValue() {
        if (this.mainNotification) {
            if (this.mainNotification.data?.stepCount) {
                return (
                    (this.mainNotification.data.step / this.mainNotification.data.stepCount) * 100
                );
            }
            if (this.mainNotification.extraData?.stepCount) {
                return (
                    (this.mainNotification.extraData.step /
                        this.mainNotification.extraData.stepCount) *
                    100
                );
            }
        }
        return 0;
    }
}

export default toNative(Notification);
</script>

<style scoped>
.notification {
    border-radius: 8px;
    transition: 0.3s;
}

.notification:hover {
    background-color: #fef8ee;
}

.notification--sub-card {
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background-color: #f7fafc;
    margin-bottom: 0.2rem;
}

.is-last {
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
}

.custom-menu .v-overlay__content {
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    background-color: white;
}
</style>
